import { StatisticsActionTypes, StatisticsState, StatisticsAction, PeriodType } from '../../constants/Statistics';

// 現在の週の月曜日を取得（ISO 8601形式）
function getCurrentWeekMonday(): string {
  const today = new Date();
  const day = today.getDay();
  const diff = today.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(today.setDate(diff));
  return formatDate(monday);
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const initialState: StatisticsState = {
  loading: false,
  error: null,
  periodType: 'weekly' as PeriodType,
  date: getCurrentWeekMonday(),
  period: null,
  data: [],
  total: 0,
};

export default function statistics(state = initialState, action: StatisticsAction): StatisticsState {
  switch (action.type) {
    case StatisticsActionTypes.FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case StatisticsActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        period: action.payload.period,
        data: action.payload.data,
        total: action.payload.total,
      };

    case StatisticsActionTypes.FETCH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case StatisticsActionTypes.SET_PERIOD_TYPE:
      return {
        ...state,
        periodType: action.payload,
      };

    case StatisticsActionTypes.SET_DATE:
      return {
        ...state,
        date: action.payload,
      };

    case StatisticsActionTypes.RESET:
      return initialState;

    default:
      return state;
  }
}
